module.exports = __webpack_public_path__ + "static/media/last-hand-card.f0d0c05c.svg";